module.exports = __webpack_public_path__ + "static/projekt_indywidualny_d08-3ab7d35b4a1d85fb42861d4d17bc1295.jpg";